import Vue from 'vue'
import VueCookies from 'vue-cookies'
import App from './App.vue'
import './plugins/axios'
import router from './router'
import store from './store'

// https://github.com/MatteoGabriele/vue-analytics
import VueAnalytics from 'vue-analytics'
Vue.use(VueAnalytics, {
  id: 'UA-172839291-1',
  router
})

Vue.config.productionTip = false

require('./includes.js')

import moment from 'moment'
import vueMoment from 'vue-moment'
moment.updateLocale('en', {
  relativeTime: {
    future: 'in %s',
    past: '%s',
    s: '<1m ago',
    ss: '<1m ago', // '%d seconds',
    m: '1m ago',
    mm: '%dm ago',
    h: '1h ago',
    hh: '%dh ago',
    d: '1d ago',
    dd: '%dd ago',
    M: '1mo ago',
    MM: '%dmos ago',
    y: '1y ago',
    yy: '%dy ago'
  }
})
Vue.use(vueMoment, { moment })
Vue.use(VueCookies, { expires: '14d' })
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
